import { Button } from 'antd';

import { OtherEntityType } from '../common/types';

import './quickAddEntityButtons.scss';

const QUICK_ADD_BUTTONS: { key: OtherEntityType; label: string }[] = [
    { key: 'products', label: '+ Товар' },
    { key: 'services', label: '+ Услуга' },
    { key: 'tasks', label: '+ Задача' },
];

interface Props {
    canAddEntity: boolean;
    addingEntityType: OtherEntityType | null;
    onSelect: (entityType: OtherEntityType) => void;
}

export const QuickAddEntityButtons: React.FC<Props> = ({
    canAddEntity,
    addingEntityType,
    onSelect,
}) => (
    <div className="quick-add-entity-buttons">
        {QUICK_ADD_BUTTONS.map(({ key, label }) => {
            const isThisEntityAdding = addingEntityType === key;

            return (
                <Button
                    key={key}
                    type="text"
                    loading={isThisEntityAdding}
                    disabled={!isThisEntityAdding && (!canAddEntity || !!addingEntityType)}
                    onClick={() => onSelect(key)}
                    style={{ color: canAddEntity ? '#1677ff' : 'rgba(0, 0, 0, 0.25)' }}
                >
                    {label}
                </Button>
            );
        })}
    </div>
);
